import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class StudentInfoService {

  private _token: string = localStorage.getItem('token');
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  postStudentInfo$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'studentsinfo/add-stud-calc-data', info, {
        headers: headers
    })
    .catch(this.handleErrorObservable);
  }
  updateCompletedPer$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'studentsinfo/update-stud-completed-record', info, {
        headers: headers
    })
    .catch(this.handleErrorObservable);
  }

  getStudentInfo(): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'studentsinfo/get-stud-calc-list', options)
    .catch(this.handleErrorObservable);
  }

  removeInfo(id): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.config.apiEndpoint + 'studentsinfo/delete-stud-calc-record/' + id, options)
    .catch(this.handleErrorObservable);
  }

  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/student-info.service.ts